import { Input as ChakraInput, InputGroup, InputRightElement, Stack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

import InputLabel from 'components/input-label'

import theme from 'theme'

import type { InputLabelProps } from 'components/input-label'

type Props = {
  type?: 'text' | 'password'
  label: InputLabelProps
  caption?: string
  value?: string
  minLength?: number
  maxLength?: number
  isError?: boolean
  isDisabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeypress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

const Input = ({
  type = 'text',
  label,
  caption,
  minLength,
  maxLength,
  isError,
  isDisabled,
  value = '',
  onChange,
  onKeypress,
}: Props) => {
  const [show, setShow] = useState(false)

  return (
    <Stack w="100%" direction="column" align="flex-start" spacing="2px">
      {label && <InputLabel {...label} />}
      <InputGroup>
        <ChakraInput
          type={type === 'text' || show ? 'text' : 'password'}
          border={theme.baseComponents.input.border[isError ? 'error' : 'default']}
          _hover={{ border: theme.baseComponents.input.border.hover }}
          _active={{ border: theme.baseComponents.input.border.focus }}
          isDisabled={isDisabled}
          onChange={onChange}
          {...(onKeypress && { onKeyUp: onKeypress })}
          {...(!isDisabled && { backgroundColor: theme.colors.white })}
          {...(onChange ? { value: value } : { defaultValue: value })}
          {...(minLength && { minLength: minLength })}
          {...(maxLength && { maxLength: maxLength })}
        />
        {type === 'password' && (
          <InputRightElement px="24px" _hover={{ cursor: 'pointer' }}>
            <FontAwesomeIcon
              icon={['far', show ? 'eye' : 'eye-slash']}
              size="lg"
              color={theme.baseColors.text.disabled}
              onClick={() => setShow(!show)}
            />
          </InputRightElement>
        )}
      </InputGroup>
      {caption && (
        <Text as="label" textStyle="caption">
          {caption}
        </Text>
      )}
    </Stack>
  )
}

export default Input
